import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import axios from "axios";
import SelectAsyncPaginate from "../../UI/ReactAsyncSelect";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs, filterInputsUpdateSelect } = props;

  const [partnersOption, setPartnersOption] = React.useState(null);
  function handleChangePartners(value) {
    setPartnersOption(value);
    filterInputsUpdateSelect("partnerName", value?.label);
  }

  const loadOptionsPartner = async (search, loadedOptions, { page }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}partner/filter?name=${search}&Skip=${page * 30}&Take=30`

    );

    let responseJSON = await response.data.data;
    responseJSON = responseJSON.map((item) => ({
      value: item.id,
      label: item.name
    }));

    return {
      options: responseJSON,
      hasMore: responseJSON.length ? true : false,
      additional: {
        page: page + 1
      }
    };

  };


  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Merchant filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="name"
                  name="name"
                  label="Name"
                  placeholder="Name"
                  className="w-100"
                  value={filterInputs.name}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  className="w-100"
                  value={filterInputs.email}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="phone"
                  name="phone"
                  label="Phone"
                  placeholder="Phone"
                  className="w-100"
                  value={filterInputs.phone}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                {/* <TextField
                  id="partnerName"
                  name="partnerName"
                  label="Partner"
                  placeholder="Partner"
                  className="w-100"
                  value={filterInputs.partnerName}
                  onChange={(e) => filterInputsUpdate(e)}
                /> */}
                <SelectAsyncPaginate
                  loadOptions={loadOptionsPartner}
                  onChange={handleChangePartners}
                  value={partnersOption}
                  label="Choose partner"
                  placeholder="Choose partner"
                  inputId="partnerName"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
